<template>
  <div>
    <div class="row">
        <div class="col-md-3">
            <multiselect @input="reload" v-model="selectedMarketplaces" :options="marketplaces" multiple placeholder="Selecteer een marktplaats" selected-label="✔" select-label="" deselect-label="✔" />
        </div>
        <div class="col-md-3">
         <input class="form-control" @change="reload" type="date" placeholder="Periode van" v-model="dateFrom" style="height: 40px;">
        </div>
          <div class="col-md-3">
         <input class="form-control" @change="reload" type="date" placeholder="Periode van" v-model="dateTo" style="height: 40px;">
        </div>
        <div class="col-md-3">
            <div>
                <label class="css-control css-control-sm css-control-primary css-switch">
                <input type="checkbox" class="css-control-input" v-model="includeVat" @change="reload">
                <span class="css-control-indicator"></span> Incl btw
                </label>
                        
                <label class="css-control css-control-sm css-control-primary css-switch">
                <input type="checkbox" class="css-control-input" v-model="includeShipping" @change="reload">
                <span class="css-control-indicator"></span> Incl verzendkosten
                </label>

                <label class="css-control css-control-sm css-control-primary css-switch">
                <input type="checkbox" class="css-control-input" v-model="selectAllMarketplaces" @change="reload">
                <span class="css-control-indicator"></span> Selecteer alle kanalen
                </label>
            </div>
        </div>
    </div>
    <div v-if="!result" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>
    <div v-else>
      <div class="chart">
          <line-chart :result="result" />
      </div>
      <div class="container revenue-numbers">
        <div class="row gx-10">
          <div class="col">
            <div class="p-3 mt-3">
              <h5>Labels</h5>
              <h5>
                Geselecteerde periode
              </h5>
              <h5 class="mt-10">
                Geselecteerde periode (vorig jaar)
              </h5>
            </div>
          </div>
          <div class="col">
            <div class="p-3 border bg-light">
              <h5>Omzet</h5>
              <h3>
                €
                <span>
                  {{result.total_revenue}}
                </span>
              </h3>
              <h3>
                €
                <span>
                  {{result.historical_total_revenue}}
                </span>
              </h3>
                <b v-if="result.percentage_change_revenue >= 30" class="text-success">{{result.percentage_change_revenue + '%'}}</b>
                <b v-if="result.percentage_change_revenue < 30 && result.percentage_change_revenue >= 0" class="text-warning">{{result.percentage_change_revenue + '%'}}</b>
                <b v-if="result.percentage_change_revenue < 0" class="text-danger">{{result.percentage_change_revenue + '%'}}</b>
                <span> t.a.v vorige jaar in dezelfde periode </span>
            </div>
          </div>
          <div class="col">
            <div class="p-3 border bg-light">
              <h5>Orders</h5>
              <h3>
                <span>
                  {{result.order_amount}}
                </span>
              </h3>
              <h3>
                <span>
                  {{result.historical_order_amount}}
                </span>
              </h3>
                <b v-if="result.percentage_change_order_amount >= 30" class="text-success">{{result.percentage_change_order_amount + '%'}}</b>
                <b v-if="result.percentage_change_order_amount < 30 && result.percentage_change_order_amount >= 0" class="text-warning">{{result.percentage_change_order_amount + '%'}}</b>
                <b v-if="result.percentage_change_order_amount < 0" class="text-danger">{{result.percentage_change_order_amount + '%'}}</b>
                <span> t.a.v vorige jaar in dezelfde periode </span>
            </div>
          </div>
          <div class="col">
            <div class="p-3 border bg-light">
              <h5>Gemiddelde orderwaarde</h5>
              <h3>
                <span>
                  {{ result.average_order_value }}
                </span>
              </h3>
              <h3>
                <span>
                  {{ result.historical_average_order_value }}
                </span>
              </h3>
                <b v-if="result.percentage_change_order_value >= 30" class="text-success">{{result.percentage_change_order_value + '%'}}</b>
                <b v-if="result.percentage_change_order_value < 30 && result.percentage_change_order_value >= 0" class="text-warning">{{result.percentage_change_order_value + '%'}}</b>
                <b v-if="result.percentage_change_order_value < 0" class="text-danger">{{result.percentage_change_order_value + '%'}}</b>
                <span> t.a.v vorige jaar in dezelfde periode </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from './components/LineChart'
import http from '../utils/http'
import dayjs from 'dayjs'

export default {
  components: { LineChart },
  data () {
    return {
      result: null,
      dateFrom: dayjs().format('YYYY-MM-DD'),
      dateTo: dayjs().format('YYYY-MM-DD'),
      marketplaces: ['vm_nl', 'vm_de', 'vm_fr', 'vm_en', 'vm_sr', 'channable_nl', 'channable_de', 'channelengine'],
      selectedMarketplaces: ['vm_nl'],
      selectAllMarketplaces: false,
      includeShipping: true,
      includeVat: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      const params = {
        'dateFrom': this.dateFrom,
        'dateTo': this.dateTo,
        'marketplaces': this.selectedMarketplaces,
        'shipping': this.includeShipping,
        'vat': this.includeVat
      }

      http.get('/report-revenue', { params })
        .then((result) => {
          this.result = result.data
        })
    },
    reload () {
      this.selectedMarketplaces = this.selectAllMarketplaces ? this.marketplaces : ['vm_nl']
      this.result = null
      this.load()
    }
  }
}
</script>
<style scoped>
.select-period {
  width: 200px;
}
.chart {
    margin-top: 50px;
}
.revenue-numbers {
  margin-left: 25px !important;
  padding-top: 50px;
}
</style>



// WEBPACK FOOTER //
// RevenueReportPage.vue?14f9918f